import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

/* Common Components */
import Header from "./components/Header";
import Footer from "./components/Footer";

/* Home Sections */
import Hero from "./components/Hero";
import About from "./components/About";
import Service from "./components/Service";
import CountPage from "./components/CountPage";
import Parallax from "./components/Parallax";
import Review from "./components/Review";
import FAQ from "./components/FAQ";
import Map from "./components/Map";

/* Pages */
import Gallery from "./components/Gallery";
import Blog from "./components/Blog";
import NotFound from "./components/404";

/* Home Layout */
const Home = () => {
  return (
    <>
      <Header />

      <section id="home">
        <Hero />
      </section>

      <section id="about">
        <About />
      </section>

      <section id="services">
        <Service />
      </section>

      <CountPage />
      <Parallax />
      <Review />
      <FAQ />

      <section id="contact">
        <Map />
      </section>

      <Footer />
    </>
  );
};

const GalleryPage = () => {
  return (
    <>
      <Header />
      <Gallery />
      <Footer />
    </>
  );
};

const BlogPage = () => {
  return (
    <>
      <Header />
      <Blog />
      <Footer />
    </>
  );
};

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/gallery" element={<GalleryPage />} />
        <Route path="/blog" element={<BlogPage />} />

        {/* 404 WITHOUT HEADER & FOOTER */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
